import Infotext from './Infotext.vue';

export default Infotext;



// WEBPACK FOOTER //
// ./src/components/parts/infotext/index.ts